export const BASE_URL = "https://api.mynda.co/api/v1"; //"http://localhost:3001/api/v1";
